/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * fire classification of item or location.
 * @export
 */
export const FireClassEnum = {
    FIRE_CLASSIFICATION_UNSPECIFIED: 0,
    FIRE_CLASSIFICATION_NORMAL_FIRE_RISK: 1,
    FIRE_CLASSIFICATION_HIGH_FIRE_RISK: 2,
    FIRE_CLASSIFICATION_SEVERE_FIRE_RISK: 3,
} as const;
export type FireClassEnum = typeof FireClassEnum[keyof typeof FireClassEnum];


export function instanceOfFireClassEnum(value: any): boolean {
    for (const key in FireClassEnum) {
        if (Object.prototype.hasOwnProperty.call(FireClassEnum, key)) {
            if (FireClassEnum[key as keyof typeof FireClassEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FireClassEnumFromJSON(json: any): FireClassEnum {
    return FireClassEnumFromJSONTyped(json, false);
}

export function FireClassEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FireClassEnum {
    return json as FireClassEnum;
}

export function FireClassEnumToJSON(value?: FireClassEnum | null): any {
    return value as any;
}

export function FireClassEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FireClassEnum {
    return value as FireClassEnum;
}

